import { Numeric }	from "@v3/data/numeric";
import { Integer }	from "@v3/data/primitive";

// whole number of days
export type DayInterval		= Numeric.Value<typeof Base>;

const Base	= Integer.rebrand("DayInterval");

namespace Extension {
	export const zero	= Base.brand(0);
	export const one	= Base.brand(1);

	// eslint-disable-next-line @typescript-eslint/no-unsafe-unary-minus
	export const negate		=	(it:DayInterval):DayInterval				=> Base.brand(-it);
	export const add		=	(a:DayInterval, b:DayInterval):DayInterval	=> Base.brand(a + b);
	export const substract	=	(a:DayInterval, b:DayInterval):DayInterval	=> Base.brand(a - b);
};

export const DayInterval	= { ...Extension, ...Base };
